module.exports = __webpack_public_path__ + "media/images/sf-faf4c688.png";